import { useEffect } from "react";

const useSessionTimeout = (logout, timeout = 90 * 60 * 1000) => {
  useEffect(() => {
    let timer = setTimeout(logout, timeout);

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(logout, timeout);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
    };
  }, [logout, timeout]);
};

export default useSessionTimeout;